import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Layout from '../components/Layout';
import { lazy, Suspense } from 'react';
import AuthLayout from '../components/Layout/auth';

const ProtectedRoute = lazy(() => import('../components/ProtectedRoute'));
const Login = lazy(() => import('../pages/Auth'));
const Home = lazy(() => import('../pages/Home'));

const AssessmentOfSuitabilityForm = lazy(() => import('../pages/Documents/assessment-suitability-form'));
const DataCollectionForm = lazy(() => import('../pages/Documents/data-collection-form'));

const CourseDetails = lazy(() => import('../pages/CourseDetails'));
const ExamSheet = lazy(() => import('../pages/CourseDetails/exam-sheet'));
const LiveWebinars = lazy(() => import('../pages/CourseDetails/live-webinare'));
const VocationalSheet = lazy(() => import('../pages/CourseDetails/vocational-sheet'));
const Exercises = lazy(() => import('../pages/CourseDetails/exercises'));
const ExamHistory = lazy(() => import('../pages/ExamHistory'));
const CarrierCertificates = lazy(() => import('../pages/CarrierCertificates'));
const LiveWebinare = lazy(() => import('../pages/LiveWebinare'));
const SchriftlichePruefung = lazy(() => import('../pages/SchriftlichePruefung'));
const MuendlichePruefung = lazy(() => import('../pages/MuendlichePruefung'));
const Feedbackbogen = lazy(() => import('../pages/Feedbackbogen'));


const AppRouter = () => {

    const router = createBrowserRouter([
        {
            path: '/login',
            element: (
                <AuthLayout >
                    <Suspense fallback={null}>
                        <Login />
                    </Suspense>
                </AuthLayout>
            ),
        },
        {
            element: (
                <ProtectedRoute>
                    <Layout />
                </ProtectedRoute>
            ),
            children: [
                { path: '/', element: <Home /> },
                { path: '/exam-history', element: <ExamHistory /> },
                { path: '/carrier-certificates', element: <CarrierCertificates /> },
                { path: '/live-webinare', element: <LiveWebinare /> },
                { path: '/schriftliche-pruefung', element: <SchriftlichePruefung /> },
                { path: '/muendliche-pruefung', element: <MuendlichePruefung /> },
                { path: '/feedbackbogen', element: <Feedbackbogen /> },
            ]
        },
        {
            element: (<Layout normal={true} />),
            children: [
                {
                    path: '/assessment-suitability-form',
                    element: <AssessmentOfSuitabilityForm />
                },
                {
                    path: '/data-collection-form',
                    element: <DataCollectionForm />
                },
            ]
        },
        {
            element: (
                <Layout
                    normal={true}
                    childSx={{ paddingY: "0 !important" }}
                    parentSx={{ paddingX: "0 !important" }}
                />
            ),
            children: [
                {
                    path: '/course-details',
                    element: <CourseDetails />
                },
                {
                    path: '/live-webinars',
                    element: <LiveWebinars />
                },
                {
                    path: '/exam-sheet',
                    element: <ExamSheet />
                },
                {
                    path: '/vocational-sheet',
                    element: <VocationalSheet />
                },
                {
                    path: '/exercises',
                    element: <Exercises />
                },
            ]
        },
        {
            path: '*',
            element: <h1 style={{ textAlign: 'center' }}>404 Error - Nothing here...</h1>
        }
    ]);

    return <RouterProvider key="router-provider" router={router} />;
};

export default AppRouter;